import { render, staticRenderFns } from "./DocumentsB2b.vue?vue&type=template&id=6ae8e126&scoped=true&"
import script from "./DocumentsB2b.vue?vue&type=script&lang=js&"
export * from "./DocumentsB2b.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsB2b.vue?vue&type=style&index=0&id=6ae8e126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae8e126",
  null
  
)

export default component.exports